/* « P » en ruban doré cerclé : ruban fin (pli en haut, croisement sur la
   tige, queue en pointe) dans un anneau d'or, esprit sceau / monogramme. */
export default function LogoMark({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="pureva-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#E3B96C" />
          <stop offset="0.5" stopColor="#C99445" />
          <stop offset="1" stopColor="#A87A35" />
        </linearGradient>
      </defs>
      <circle cx="24" cy="24" r="22" stroke="#C99445" strokeWidth="1.2" />
      <path
        d="M16 36V12h10.5a6.5 6.5 0 0 1 0 13H16"
        stroke="url(#pureva-gold)"
        strokeWidth="4.5"
        strokeLinecap="butt"
        strokeLinejoin="miter"
      />
      <path d="M13.75 10h4.5l-4.5 4.5V10z" fill="#8A6428" />
      <path d="M13.75 22.75h4.5v4.5h-4.5z" fill="#8A6428" />
      <path d="M13.75 36h4.5l-2.25 3-2.25-3z" fill="#C99445" />
    </svg>
  );
}
